export default __webpack_public_path__ + "static/media/how-blissway.78145aac.jpg";